import { observable, action } from 'mobx'

import Package from 'models/Package';

class SelectedPackageStore {

  @observable isEditing;
  @observable selectedPackage;

  constructor() {
    this.AdventureStoreIndex = null;
    this.isEditing = false;
    this.selectedPackage = new Package()
  }

  @action
  createPackage() {
    this.AdventureStoreIndex = null;
    this.isEditing = false;
    this.selectedPackage = new Package()
  }

  @action
  setSelectedPackage(selectedPackage, index) {
    this.isEditing = true
    this.AdventureStoreIndex = index
    this.selectedPackage = selectedPackage
  }

  @action
  setPackageDescription(data) {
    this.selectedPackage.name = data.name
    this.selectedPackage.price = data.price
    this.selectedPackage.description = data.description
  }

  @action
  setPackageItens(itens) {
    this.selectedPackage.items = itens
  }


  @action
  setPackageAsFeatured() {
    this.selectedPackage.isDefault = true
  }
}

export default new SelectedPackageStore();



// WEBPACK FOOTER //
// ./src/modules/adventure/containers/modules/packageData/SelectedPackageDataStore.js